import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService } from '../../../core';
import { Classificacao } from '../classificacao';
import { ClassificacaoFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class ClassificacaoCrudHttpService implements Crud<Classificacao> {
    resource = 'classificacao';

    constructor(private crudService: CrudService) { }

    /** Pesquisa todas classificações cadastradas */
    search(): Observable<Classificacao[]> {
        return this.crudService.search<Classificacao>(this.resource);
    }

    /** Pesquisa todas classificações cadastradas */
    searchWithFilter(filter: ClassificacaoFilter): Observable<Classificacao[]> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }
        return this.crudService.search<Classificacao>(this.resource, {params});
    }

    /** Procura uma única classificação através do seu ID */
    find(id: number): Observable<Classificacao> {
        return this.crudService.find<Classificacao>(this.resource, id);
    }

    /** Carrega uma única classificação através do seu ID */
    load(id: number): Observable<Classificacao> {
        return this.crudService.load<Classificacao>(this.resource, id);
    }

    /** Insere uma nova classificação */
    insert(entity: Classificacao): Observable<Classificacao> {
        return this.crudService.insert<Classificacao>(this.resource, entity);
    }

    /** Altera uma classificação existente */
    update(entity: Classificacao): Observable<Classificacao> {
        return this.crudService.update<Classificacao>(this.resource, entity);
    }

    /** Exclui uma classificação através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
